module.exports = __webpack_public_path__ + "img/collection-memoireRingsCheap.6b71ab1.jpg";